// Loose words set over a photo. `mix-blend-difference` flips each word's colour
// against whatever is underneath, so it reads on both dark and bright parts of the image.
// Each entry is [text, position/size classes]. With `hidden`, the words fade out;
// they fade back in one after another.
export default function ScatterWords({ words, hidden = false }) {
  return (
    <div aria-hidden="true" className="pointer-events-none absolute inset-0 select-none overflow-hidden">
      {words.map(([text, pos], i) => (
        <span
          key={text}
          style={{ transitionDelay: hidden ? '0ms' : `${i * 70}ms` }}
          className={`absolute whitespace-nowrap font-times leading-none text-white mix-blend-difference transition-opacity duration-500 ${pos} ${
            hidden ? '!opacity-0' : ''
          }`}
        >
          {text}
        </span>
      ))}
    </div>
  );
}
